import { getAllPieces, getSolde } from '@/api/compteClient/index';
import genererCriteresRechercheCompteClient from '@/services/bodac/client/criteresRecherche/genererCriteresRechercheCompteClient';
import * as types from './compteClient-mutation-type';
import * as allTypes from '../mutation-type';

function initialState() {
  return {
    items: [],
    total: 0,
    solde: 0,
    maxDatemouvement: null,
    critereRecherche: genererCriteresRechercheCompteClient(),
    lastPayload: {},
  };
}

const state = initialState();

const namespaced = true;

const mutations = {
  [types.SET_ITEMS](state, items) {
    state.items = items;
  },
  [types.SET_TOTAL](state, total) {
    state.total = total;
  },
  [allTypes.RESET_STATE](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
  [types.SET_CRITERE](state, critere) {
    state.critereRecherche = critere;
  },
  [types.SET_LASTPAYLOAD](state, payload) {
    state.lastPayload = payload;
  },
  [types.SET_SOLDE](state, value) {
    state.solde = value;
  },
  [types.SET_DATE_SOLDE](state, value) {
    state.maxDatemouvement = value;
  },
};

const actions = {
  async loadCompteClient({ commit }, ObjectFilter) {
    const response = await getAllPieces(ObjectFilter);
    commit(types.SET_TOTAL, response.data.result.totalCount);
    commit(types.SET_ITEMS, response.data.result.items);
    commit(types.SET_LASTPAYLOAD, ObjectFilter);
    return {};
  },
  async loadSoldeClient({ commit }, tiersId) {
    try {
      const response = await getSolde(tiersId);
      commit(types.SET_SOLDE, response.data.result.solde);
      commit(types.SET_DATE_SOLDE, response.data.result.maxDateMouvement);
    } catch (error) {
      commit(types.SET_SOLDE, 0);
      commit(types.SET_DATE_SOLDE, null);
      throw (error);
    }
  },
};

const getters = {
  items: state => {
    return state.items;
  },
  total: state => {
    return state.total;
  },
  critereRecherche: state => {
    return state.critereRecherche;
  },
  lastPayload: state => {
    return state.lastPayload;
  },
  solde: state => {
    return state.solde;
  },
  dateSolde: state => {
    return state.maxDatemouvement;
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
